export default "__VITE_ASSET__DD0LOVnH__"